import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers/index';
import persistState from 'redux-localstorage'



export default function configureStore(initialState) {

    const enhancer = compose(
        persistState(),
    );

    const store = createStore(
        rootReducer,
        applyMiddleware(
            thunkMiddleware, // lets us dispatch() functions
        ),
        enhancer
    );

    return store;
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js